<template>
    <div class="banner-area">
        <div class="container p-l-30 p-r-30">
            <div class="row flex-lg-row flex-column-reverse justify-content-between">
                <div class="col-lg-5 col-md-12">
                    <div class="banner-text">
                        <h4><span class="d-block">Thinking of group contributions or raising funds?
                            </span> Launch a Campaign</h4>
                        <p>Easily set up a fundraiser or a group contribution campaign to pool funds together from your members and well-wishers for that impactful project, special goal or social support project</p>
                        <router-link v-if="isAuthenticated" :to="{name:'campaign-dashboard'}" class="btn btn-gradient btn-lg btn-mw text-uppercase">Add Campaign</router-link>
                        <router-link v-else to="/authentication/register" class="btn btn-gradient btn-lg btn-mw text-uppercase">Register Now</router-link>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="banner-img text-center">
                        <img class="img-fluid" src="@/assets/images/launch-page/banner-campaign.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "CampaignBanner",
    computed: {
        ...mapGetters(["currentUser", "isAuthenticated"])
    },
}
</script>